import Header from "@/reusable_sections/Header";
import HeroAbout from "./sections/HeroAbout";
import Overview from "./sections/Overview";
import Statistics from "./sections/Statistics";
import Marquee from "./sections/Marquee";
import Leadership from "./sections/Leadership";
import AssembliesCarousel from "./sections/AssembliesCarousel";
import Footer from "@/reusable_sections/Footer";
export default function AboutUsPage() {
  return <div className="acad-react-page acad-about-us-page">
      <Header />
      <HeroAbout />
      <Overview />
      <Statistics />
      <Marquee />
      <Leadership />
      <AssembliesCarousel />
      <Footer />
    </div>;
}
